import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@mui/material'
import { FC } from 'react'

type ISimpleDialogProps = {
  open: boolean
  title: string
  message: string
  buttonTextOk?: string
  buttonTextNo?: string
  okButtonColor?: string
  handleClose: (execute?: boolean) => void
}

export const SimpleDialog: FC<ISimpleDialogProps> = ({open, title, message, buttonTextOk = 'OK', buttonTextNo = 'NO', okButtonColor = 'error', handleClose }) => {
  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
    >
      <DialogTitle id="alert-dialog-title" sx={{ fontSize: '20px', minWidth: '600px' }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" color='inherit' sx={{ fontSize: '16px' }}>{message.split(/(\n)/g).map(text => (text === '\n') ? <br/> : text)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color='inherit' sx={{ fontSize: '14px' }}>{buttonTextNo}</Button>
        <Button onClick={() => handleClose(true)} autoFocus color={okButtonColor} sx={{ fontSize: '14px' }}>
          {buttonTextOk}
        </Button>
      </DialogActions>
    </Dialog>
  )
}